import React from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { text, title } from "framer-motion/client";
import { color } from "framer-motion";

const BlogSection = () => {
  const navigate = useNavigate();

  const cards = [
    {
      title: "Blog",
      icon: "📝",
      color: "primary",
      text: "View and manage blog posts",
      action: () => navigate("/customer/dashboard/blog/list"),
    },
    {
      title: "Research",
      icon: "📚",
      color: "warning",
      text: "Research and repository",
      action: () => navigate("/customer/dashboard/blog/research"),
    },
   
  ];

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">📝 Blog & Research</h2>
      <div className="row g-4">
        {cards.map((card, index) => (
          <div key={index} className="col-12 col-sm-6">
            <div
              className={`card text-white bg-${card.color} h-100 shadow`}
              style={{ cursor: "pointer", transition: "transform 0.2s" }}
              onClick={card.action}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <div className="card-body text-center">
                <div style={{ fontSize: "40px" }}>{card.icon}</div>
                <h5 className="card-title mt-2">{card.title}</h5>
                <p className="card-text">{card.text}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogSection;
